// https://github.com/w3c/IntersectionObserver/tree/master/polyfill - Polyfill for older browsers
// Add lazy-load class to elements

document.addEventListener('DOMContentLoaded', function() {

    let lazyElements = [].slice.call(document.querySelectorAll('.lazy-load'));

    if ('IntersectionObserver' in window) {

        const options = {
            //Offset of when to lazy load - currently 120px before image/background is shown
            rootMargin: '0px 0px 120px 0px',
        };

        let lazyElementObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {

                if (entry.isIntersecting) {
                    const lazyElement = entry.target.nodeName;

                    if (lazyElement == 'IMG') {
                        let lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove('lazy-load');
                        lazyElementObserver.unobserve(lazyImage);
                    } else {
                        let lazyBackground = entry.target;
                        lazyBackground.style.backgroundImage = 'url(' + lazyBackground.dataset.src + ')';
                        lazyBackground.classList.remove('lazy-load');
                        lazyElementObserver.unobserve(lazyBackground);
                    }
                }
            });
        }, options);

        lazyElements.forEach(function(lazyElement) {
            lazyElementObserver.observe(lazyElement);
        });
    }
});


// WEBPACK FOOTER //
// ./scripts/autoload/lazyLoad.js